export default __webpack_public_path__ + "static/media/player_poster.47fa2706.png";